<form name="ReasonForm" (ngSubmit)="ReasonForm.form.valid && Save()" #ReasonForm="ngForm">
    <div class="card">
        <div class="card-header">
            <div class="card-title">Reason Master</div>
        </div>
        <div class="m-2 card-body">
            <div class="row">
                <div class="col-md-12 px-1">
                    <label>Reason Name</label>
                    <input name="ReasonName" maxlength="100" class="form-control" placeholder="Ex."
                        [(ngModel)]="Detail.ResignationReason" #ReasonName="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter Reason name.
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary me-1" (click)="close()"
                            [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                            Cancel
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>

                        <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Save':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>